export default "__VITE_ASSET__5ee658f9__"